module.exports = __webpack_public_path__ + "media/batman@sm-a56457b301aa95f86dd569e0361d0a97.jpg";